import { Injectable } from '@angular/core';

import { AcknowledgementOfDebt, Expense, UserExpense } from '@models';
import { CrudService, HttpService, IResponsePayload } from '@services';

@Injectable({ providedIn: 'root' })
export class ExpenseService extends CrudService<Expense> {
  constructor(http: HttpService) {
    super('expense', http);
  }

  async addUserExpense(
    userId: string,
    expenseId: string,
    acknowledgementOfDebt?: AcknowledgementOfDebt,
    file?: File
  ): Promise<UserExpense> {
    let res: IResponsePayload<UserExpense>;
    if (!file) {
      res = await this.http.post<UserExpense>(`${this.url}/user`, {
        userId,
        expenseId,
      });
    } else {
      res = await this.http.postWithFile<UserExpense>(
        `${this.url}/aod/user`,
        {
          userId,
          expenseId,
          acknowledgementOfDebt,
        },
        file
      );
    }
    if (!res.success) throw new Error(res.message);
    return res.data;
  }

  async getUserExpenses(userId: string): Promise<UserExpense[]> {
    const res = await this.http.get<UserExpense[]>(
      `${this.url}/user/${userId}`
    );
    if (!res.success) throw new Error(res.message);
    return res.data;
  }

  async deleteUserExpense(userId: string, expenseId: string): Promise<void> {
    const url = `${this.url}/${expenseId}/user/${userId}`;
    const res = await this.http.delete(url);
    if (!res.success) throw new Error(res.message);
  }
}
